module.exports = __webpack_public_path__ + "2141b99db5ff6911b6e6545ef47e3f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/ja.png
// module id = 1057
// module chunks = 0